import { __decorate } from "tslib";
import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Header Component
 */
let NewsComponent = class NewsComponent {
    constructor(httpClient, route, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.route = route;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.news = [];
        this.offset = 0;
        this.search = {};
        this.searchActive = false;
        this.noNews = false;
        this.numberOfNews = 0;
        this.nmrOfNewsBeforeAnotherSearch = 0;
        this.accentColor = '';
        this.backColor = '';
        this.textColor = '';
        this.shouldShowReturnButton = false;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.sub = this.route
            .params
            .subscribe(params => {
            this.active = +params['id'] || -1;
            this.httpClient.get('news/count').subscribe((data) => {
                this.numberOfNews = data['count'];
            });
        });
        this.loadNews();
    }
    ngAfterContentChecked() {
        if (this.active !== -1) {
            if (this.active !== this.scrolledActive) {
                if (this.news.some(e => e.id === this.active)) {
                    const newsId = document.getElementById('news_' + this.active);
                    if (newsId !== null) {
                        this.scrolledActive = this.active;
                        newsId.scrollIntoView({ behavior: 'auto', block: 'start' });
                    }
                }
                else if (this.news.length > 0) {
                    if (this.nmrOfNewsBeforeAnotherSearch !== this.news.length) {
                        this.nmrOfNewsBeforeAnotherSearch = this.news.length;
                        this.readMore();
                    }
                }
            }
        }
    }
    loadNews() {
        this.httpClient.get('news/5/' + this.offset).subscribe((result) => {
            this.news = this.news.concat(result['message']);
        });
    }
    searchNews(event) {
        if (!this.search.keyword) {
            this.searchActive = !this.searchActive;
            document.getElementById('searchField').focus();
        }
        if (this.search.keyword) {
            if (event.keyCode === 13) {
                this.httpClient.post('news/search', this.search).subscribe((result) => {
                    this.news = result['message'];
                    if (this.news.length <= 0) {
                        this.noNews = true;
                    }
                    else {
                        this.noNews = false;
                    }
                    this.search.keyword = '';
                    this.shouldShowReturnButton = true;
                });
            }
            else if (event.type === 'click') {
                this.httpClient.post('news/search', this.search).subscribe((result) => {
                    this.news = result['message'];
                    if (this.news.length <= 0) {
                        this.noNews = true;
                    }
                    else {
                        this.noNews = false;
                    }
                    this.search.keyword = '';
                    this.shouldShowReturnButton = true;
                });
            }
        }
    }
    searchAll(event) {
        this.shouldShowReturnButton = false;
        window.location.reload();
    }
    setActive(id) {
        if (this.active === id) {
            this.active = -1;
        }
        else {
            this.active = id;
        }
    }
    onScrollEvent($event) {
        this.scrollFunction();
    }
    readMore() {
        this.offset += 5;
        this.loadNews();
    }
    scrollFunction() {
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
            document.getElementById('goBack').style.display = 'block';
        }
        else {
            document.getElementById('goBack').style.display = 'none';
        }
    }
    goToTop() {
        var scrollStep = -window.scrollY / (300 / 15), scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
    }
};
NewsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    HostListener('window:scroll', ['$event'])
], NewsComponent.prototype, "onScrollEvent", null);
NewsComponent = __decorate([
    Component({
        selector: 'ecd-news',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./news.component.html")).default
    })
], NewsComponent);
export { NewsComponent };
